module.exports = __webpack_public_path__ + "img/ejemplaresdark.13fe3a4e.svg";